import { Tooltip as TooltipPrimitive } from 'radix-ui';
import type { ReactNode } from 'react';

import { cn } from '../lib/cn.ts';

export const TooltipProvider = TooltipPrimitive.Provider;

/** Подсказка при наведении и фокусе. */
export function Tooltip({
  content,
  children,
  side = 'top',
  className,
}: {
  content: ReactNode;
  children: ReactNode;
  side?: 'top' | 'right' | 'bottom' | 'left';
  className?: string;
}) {
  return (
    <TooltipPrimitive.Root delayDuration={300}>
      <TooltipPrimitive.Trigger asChild>{children}</TooltipPrimitive.Trigger>
      <TooltipPrimitive.Portal>
        <TooltipPrimitive.Content
          side={side}
          sideOffset={6}
          className={cn(
            'z-[var(--g-float-z)] max-w-72 rounded-sm bg-strong px-2 py-1 text-small font-semibold text-on-strong',
            // После задержки подсказка проявляется; при переходе между соседними (instant-open) — сразу.
            'origin-(--radix-tooltip-content-transform-origin) data-[state=delayed-open]:animate-tooltip-in',
            'data-[state=closed]:animate-tooltip-out',
            className,
          )}
        >
          {content}
        </TooltipPrimitive.Content>
      </TooltipPrimitive.Portal>
    </TooltipPrimitive.Root>
  );
}
